import type { BackendConfig, IBackendAdapter, ProviderCapabilities, ProviderLogin } from '../adapters/types'

/** Everything a backend provider contributes: its id, what the UI may offer on it, and how to build its adapter. */
export interface ProviderDefinition {
	/** Matches VITE_BACKEND_PROVIDER. */
	id: string
	capabilities: ProviderCapabilities
	/** Builds the adapter config from the build's env. */
	createConfig(env: ImportMetaEnv): BackendConfig
	createAdapter(config: BackendConfig): IBackendAdapter
	/** Set when users sign in through the provider's own OAuth instead of the tick2trade login page. */
	login?: ProviderLogin
}

const registry = new Map<string, ProviderDefinition>()

/** Called by each provider module on import; `providers/index` imports the built-in ones. */
export const registerProvider = (definition: ProviderDefinition): void => {
	registry.set(definition.id, definition)
}

export const getRegisteredProvider = (id: string): ProviderDefinition | undefined => registry.get(id)

export const registeredProviderIds = (): string[] => [...registry.keys()]
